import useUserStore from '@/store/modules/user'

export default {
    mounted(el, binding, node) {
        const {value} = binding
        const permissions = useUserStore().permissions
        if (!value || value.length === 0) {
            if (el.parentNode) {
                console.log(el.parentNode)
            }
            throw new Error("未设置权限标识")
        }
        let hasAuth = false
        if (value instanceof Array) {
            // 如果 value 是数组，检查用户是否有任何一个权限
            hasAuth = value.some(permission => permissions.includes(permission))
        } else {
            // 如果 value 是字符串，检查用户是否有该权限
            hasAuth = permissions.includes(value)
        }
        if (!hasAuth) {
            el.parentNode && el.parentNode.removeChild(el)
        }
    }
}
